import fp from 'lodash/fp';
import React from 'react';
import { FiCheck } from 'react-icons/fi';
import { connect } from 'react-redux';
import Spinner from 'react-spinkit';
import { compose, lifecycle, withProps } from "recompose";
import { bindActionCreators } from 'redux';
import { searchTileActions } from "../../../../../../../../state/modules/search-tile";
import { sessionActions } from "../../../../../../../../state/modules/session";

const mapStateToProps = (state) => ({
  adminToken: state.session.idToken,
  isRunningEndpoint: state.searchTile.isFetching
});

const mapDispatchToProps = (dispatch) => ({
  authenticate: bindActionCreators(sessionActions.session.authenticate, dispatch),
  action: bindActionCreators(searchTileActions.searchTile.getRecommended, dispatch)
});

const query = ({ isRunningEndpoint, isRunningTest }) => {
  const isRunning = isRunningTest && isRunningEndpoint
  return <div>
    test query search tile
    {
      isRunning ?
        <Spinner name='circle' className='spinner' fadeIn='none' /> :
        <FiCheck />
    }
  </div>
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withProps(
    () => {
      const params = [
        {}
      ]
      return {
        params
      }
    }
  ),
  lifecycle({
    componentDidMount() {

    },
    componentDidUpdate(prevProps) {
      const {
        isRunningTest,
        users,
        authenticate,
        adminToken,
        action,
        params,
        isRunningEndpoint,
        onComplete
      } = this.props

      if (isRunningTest && !prevProps.isRunningTest) {
        const mockUser = fp.first(users)
        authenticate(adminToken, mockUser.id, null, null, true)
        action(...params)
      }

      if (!isRunningEndpoint && prevProps.isRunningEndpoint) {
        onComplete()
      }

      if (!isRunningTest && prevProps.isRunningTest) {
        authenticate(adminToken, null, null, null, true)
      }
    }
  })
)(query)


// WEBPACK FOOTER //
// ./src/containers/pages/admin-portal/testing-portal/pressure-test/config/endpoints/searchtile/query.js